import React, { useCallback, useEffect, useState } from 'react'
import { 
  Card,
  Box,
  CardHeader,
  Container,
  Link,
  Stack,
  SvgIcon,
  Typography,
  CardContent,
  Grid,
  TextField,
  Divider,
  Switch,
  Button,
  MenuItem,
  Alert,
  AlertTitle
} from '@mui/material'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import toast from 'react-hot-toast'
import { getFirestore, addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore"
import { NavLink, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getAuth, createUserWithEmailAndPassword, signOut } from "firebase/auth"
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft'
import { QuillEditor } from '../../components/quill-editor'
import { FileDropzone } from '../../components/file-dropzone'
import LoadingButton from '@mui/lab/LoadingButton'

type RoomParams = {
  id: string;
}

export function EditarPauta() {

  const params = useParams<RoomParams>()
  const roomId = params.id
  const navigate = useNavigate()

  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(false)

  const simplesOptions = [
    {
      label: 'Projeto de resolução',
      value: 'projetoResolucao'
    },
    {
      label: 'Emenda',
      value: 'emenda'
    },
    {
      label: 'Indicação',
      value: 'indicacao'
    },
    {
      label: 'Projeto de Decreto Legislativo',
      value: 'projetoDecretoLegislativo'
    },
    {
      label: 'Projeto de emenda à Lei orgânica',
      value: 'projetoEmendaLeiOrganica'
    },
    {
      label: 'Projeto de Lei Ordinária',
      value: 'projetoLeiOrdinaria'
    },
    {
      label: 'Projeto de Lei do Poder Executivo',
      value: 'projetoLeiPoderExecutivo'
    },
    {
      label: 'Projeto de Lei do Poder Legislativo',
      value: 'projetoLeiPoderLegislativo'
    },
    {
      label: 'Projeto Substitutivo',
      value: 'projetoSubstitutivo'
    },
    {
      label: 'Requerimento',
      value: 'requerimento'
    },
    {
      label: 'Subemenda',
      value: 'subemenda'
    },
    {
      label: 'Veto',
      value: 'veto'
    },
    {
      label: 'Pareceres das Comições',
      value: 'pareceresComicoes'
    },
    {
      label: 'Parecer',
      value: 'parecer'
    },
    {
      label: 'Mensagem',
      value: 'mensagem'
    },
  ]


  const opcoesVotacaoOptions = [
    {
      label: 'Simples',
      value: 'simples'
    },
    {
      label: '2 Turnos',
      value: '2-turnos'
    },
  ]

  const formik = useFormik({
    initialValues: {
      pautaLegislativa: '',
      numero: '',
      numeroProtocolo: '',
      data: '',
      expressoes: '',
      autor: '',
      opcoes_votacao: '',
      submit: null
    },
    validationSchema: Yup.object({
      pautaLegislativa: Yup.string().max(255).required('O campo é obrigatório'),
      numero: Yup.string().required('O campo é obrigatório'),
      numeroProtocolo: Yup.string().max(255).required('O campo é obrigatório'),
      data: Yup.string().max(255).required('O campo é obrigatório'),
      expressoes: Yup.string().required('O campo é obrigatório'),
      autor: Yup.string().required('O campo é obrigatório'),
      opcoes_votacao: Yup.string().required('O campo é obrigatório'),
    }),
    onSubmit: async (values, helpers) => {
      try {
        setLoading(true)

        const db = getFirestore()
        let downloadURL = ''

        const file = files[0]
        if (file) {
          const storage = getStorage()
          try {
            //@ts-ignore
            const storageRef = ref(storage, 'files/pautas/' + file.name)
            await uploadBytes(storageRef, file)
            downloadURL = await getDownloadURL(storageRef)
          } catch (error) {
            console.error('Erro durante o upload:', error)
          }
        }

        const colecaoPaiRef = collection(db, 'users')
        const novoDocumentoRef = doc(colecaoPaiRef, 'belacruz@eleg')
        const subcolecaoRef = collection(novoDocumentoRef, 'pautas')
        const novoDocumento2Ref = doc(subcolecaoRef, `${roomId}`)
        const docSnapshot = await getDoc(novoDocumento2Ref)

        if (!docSnapshot.exists()) {
          throw new Error('O documento não existe!')
        }

        if (file) {
          const updatedData = {
            pautaLegislativa: values.pautaLegislativa !== undefined ? values.pautaLegislativa : undefined,
            numero: values.numero !== undefined ? values.numero : undefined,
            numeroProtocolo: values.numeroProtocolo !== undefined ? values.numeroProtocolo : undefined,
            data: values.data !== undefined ? values.data : undefined,
            expressoes: values.expressoes !== undefined ? values.expressoes : undefined,
            autor: values.autor !== undefined ? values.autor : undefined,
            opcoesVotacao: values.opcoes_votacao !== undefined ? values.opcoes_votacao : undefined,
            downloadURL: downloadURL
          }

          await updateDoc(novoDocumento2Ref, updatedData)
        } else {
          const documentData = docSnapshot.data()
          const updatedData = {
            ...documentData,
            pautaLegislativa: values.pautaLegislativa !== undefined ? values.pautaLegislativa : undefined,
            numero: values.numero !== undefined ? values.numero : undefined,
            numeroProtocolo: values.numeroProtocolo !== undefined ? values.numeroProtocolo : undefined,
            data: values.data !== undefined ? values.data : undefined,
            expressoes: values.expressoes !== undefined ? values.expressoes : undefined,
            autor: values.autor !== undefined ? values.autor : undefined,
            opcoesVotacao: values.opcoes_votacao !== undefined ? values.opcoes_votacao : undefined,
          }

          await updateDoc(novoDocumento2Ref, updatedData)
        }

        navigate('/pautas')

        helpers.setStatus({ success: true })
        helpers.setSubmitting(false)
        toast.success('Customer updated')

      } catch (err) {
        console.error(err)
        toast.error('Something went wrong!')
        helpers.setStatus({ success: false })
        //@ts-ignore
        helpers.setErrors({ submit: err.message })
        helpers.setSubmitting(false)
      } finally {
        setLoading(false)
      }
    }
  })

  useEffect(() => {

    const db = getFirestore()

    const ordersRef = doc(db, 'users', 'belacruz@eleg', 'pautas', `${roomId}`)

    getDoc(ordersRef)
    .then((docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data()

        formik.setValues({
          pautaLegislativa: data.pautaLegislativa,
          numero: data.numero,
          numeroProtocolo: data.numeroProtocolo,
          data: data.data,
          expressoes: data.expressoes,
          autor: data.autor,
          opcoes_votacao: data.opcoesVotacao || '',
          submit: null
        })

      } else {
        console.log("Documento não encontrado")
      }
    })
    .catch((error) => {
      console.log("Erro ao recuperar dados do documento:", error)
    })
    
  }, [])

  //@ts-ignore
  const handleFilesDrop = useCallback((newFiles) => {
    //@ts-ignore
    setFiles((prevFiles) => {
      return [...prevFiles, ...newFiles]
    })

    console.log(newFiles)
  }, [])

  //@ts-ignore
  const handleFileRemove = useCallback((file) => {
    setFiles((prevFiles) => {
      //@ts-ignore
      return prevFiles.filter((_file) => _file.path !== file.path)
    })
  }, [])

  const handleFilesRemoveAll = useCallback(() => {
    setFiles([])
  }, [])

  return (
    <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 4
    }}>
      <Container maxWidth="lg">
        <Stack spacing={4}>
          <Stack spacing={4}>
            <div>
              <NavLink to="/pautas">
                <Link
                  color="text.primary"
                  sx={{
                    alignItems: 'center',
                    display: 'inline-flex'
                  }}
                  underline="hover"
                >
                  <SvgIcon sx={{ mr: 1 }}>
                    <ArrowLeftIcon />
                  </SvgIcon>
                  <Typography variant="subtitle2">
                    Voltar
                  </Typography>
                </Link>
              </NavLink>
            </div>

            <Stack
              alignItems="flex-start"
              direction={{
                xs: 'column',
                md: 'row'
              }}
              justifyContent="space-between"
              spacing={4}
            >
              <Stack
                alignItems="center"
                direction="row"
                spacing={2}
              >
                <Stack spacing={1}>
                  <Typography variant="h4">
                    Editar Pauta Legislativa
                  </Typography>
                </Stack>
              </Stack>

            </Stack>
          </Stack>

          <form onSubmit={formik.handleSubmit}>
            <Card>
              <CardContent sx={{ pt: 1 }}>
                <Grid
                  container
                  justifyContent='space-between'
                >
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={5.85}
                  >
                  <TextField
                    error={!!(formik.touched.pautaLegislativa && formik.errors.pautaLegislativa)}
                    fullWidth
                    label="Tipo da pauta legislativa"
                    name="pautaLegislativa"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    select
                    value={formik.values.pautaLegislativa}
                  >
                    {simplesOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  </Grid>
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={5.85}
                  >
                    <TextField
                      error={!!(formik.touched.numero && formik.errors.numero)}
                      fullWidth
                      helperText={formik.touched.numero && formik.errors.numero}
                      label="Número"
                      name="numero"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.numero}
                    />
                  </Grid>
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={5.85}
                  >
                    <TextField
                      error={!!(formik.touched.numeroProtocolo && formik.errors.numeroProtocolo)}
                      fullWidth
                      helperText={formik.touched.numeroProtocolo && formik.errors.numeroProtocolo}
                      label="Número do Protocolo"
                      name="numeroProtocolo"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.numeroProtocolo}
                    />
                  </Grid>
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={5.85}
                  >
                    <TextField
                      error={!!(formik.touched.data && formik.errors.data)}
                      fullWidth
                      helperText={formik.touched.data && formik.errors.data}
                      label="Data da pauta"
                      name="data"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.data}
                      type={'date'}
                    />
                  </Grid>
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={5.85}
                  >
                    <TextField
                      error={!!(formik.touched.autor && formik.errors.autor)}
                      fullWidth
                      helperText={formik.touched.autor && formik.errors.autor}
                      label="Autor"
                      name="autor"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.autor}
                    />
                  </Grid>
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={5.85}
                  >
                    <TextField
                      error={!!(formik.touched.opcoes_votacao && formik.errors.opcoes_votacao)}
                      fullWidth
                      label="Opções de votação"
                      name="opcoes_votacao"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      select
                      value={formik.values.opcoes_votacao}
                    >
                      {opcoesVotacaoOptions.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid
                    marginTop={3}
                    xs={12}
                    md={12}
                  >
                    <Typography
                      color="InfoText"
                      sx={{ mb: 2 }}
                      variant="h6"
                    >
                      Expressões da Pauta
                    </Typography>
                    <QuillEditor
                      onChange={(value) => {
                        formik.setFieldValue('expressoes', value);
                      }}
                      placeholder="Adicione o texto..."
                      sx={{ height: 350 }}
                      value={formik.values.expressoes}
                    />
                  </Grid>
                  
                </Grid>

            <Grid
              container
              spacing={3}
              padding={3}
            >
              <Grid
                xs={12}
                md={12}
                my={2}
              >
                <Stack spacing={1}>
                  <Typography variant="h6">
                    Doumento da Pauta
                  </Typography>
                  <Typography
                    color="text.secondary"
                    variant="body2"
                  >
                    Caso queira substuir o arquivo em envie um novo, caso contrário não é necessário fazer novamente o envio.
                  </Typography>
                </Stack>
              </Grid>
              <Grid
                xs={12}
                md={12}
              >
                <FileDropzone
                  accept={{ 'application/pdf': ['.pdf'] }}
                  caption="(PDF, é permitido apenas um arquivo por pauta)"
                  files={files}
                  maxFiles={1}
                  disabled={files.length !== 0 ? true : false}
                  onDrop={handleFilesDrop}
                  onRemove={handleFileRemove}
                  onRemoveAll={handleFilesRemoveAll}
                />
              </Grid>
            </Grid>

            <Alert severity="info">
  <AlertTitle>Atenção</AlertTitle>
  A funcionalidade que permite aos parlamentares visualizarem documentos em seus tablets <strong>está disponível.</strong>
</Alert>
              </CardContent>

              <Stack
                  direction={{
                    xs: 'column',
                    sm: 'row'
                  }}
                  flexWrap="wrap"
                  spacing={3}
                  sx={{ p: 3, mt: -4 }}
                >
                  <LoadingButton
                  loading={loading}
                    disabled={formik.isSubmitting}
                    type="submit"
                    variant="contained"
                  >
                    Salvar alterações
                  </LoadingButton>
                  <Button
                    color="inherit"
                    onClick={() => {
                      navigate('/pautas')
                    }}
                    disabled={formik.isSubmitting}
                  >
                    Cancelar
                  </Button>
                </Stack>
            </Card>
          </form>
        </Stack>
      </Container>
    </Box>
  )
}
